(function () {
  if (!window?.autoDiscount?.percentValue === undefined) {
    throw new Error(`Autodiscount percent value from settings is not specified`)
  }

  const currentURL = window.location.pathname;

  const isProductPage = currentURL.includes('/products/')
  const isCollectionPage = currentURL.includes('/collections/')
  const isSubscriptionPage = currentURL.includes('/pages/subscriptions')

  if (isProductPage) {
    productPageChangePrice()
  }

 
  if (isCollectionPage) {
    collectionPageChangePrice()
  }
  if (isSubscriptionPage) {
    collectionPageChangePrice()
  }


  function productPageChangePrice() {
    if (!window?.autoDiscount?.percentValue) {
      return
    }

    const productInfo = document.querySelector('product-info');

    if (!productInfo) {
      throw new Error('tag <product-info> not found')
    }

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type !== 'childList' || window.pdpPriceChanged) {
          return
        }

        const rechargeWidget = productInfo.querySelector(
          '.shopify-block.shopify-app-block.recharge-subscription-widget'
        );
        if (!rechargeWidget || !rechargeWidget?.querySelector) {
          return
        }
        const oneTimeContainer = rechargeWidget?.querySelector('.onetime-radio')
        if (!oneTimeContainer) {
          return
        }

        const priceLabel = oneTimeContainer.querySelector('.price-label')
        const currentPrice = priceLabel.innerText
        priceLabel.innerHTML = ''

        const newPriceElement = document.createElement('span')
        newPriceElement.style.color = '#ef292e'

        const oldPriceElement = document.createElement('span')
        oldPriceElement.style.textDecoration = 'line-through'
        oldPriceElement.style.marginInlineStart = '.5rem'
        oldPriceElement.innerText = ` ${currentPrice}`

        priceLabel.append(newPriceElement, oldPriceElement)


        const {
          amount: price,
          currency
        } = parseCurrencyAmount(currentPrice)

        const newPrice = subtractPercentage(price, window.autoDiscount.percentValue)

        newPriceElement.innerText = `${currency}${newPrice}`

        // change one time purchase label
        if (window.autoDiscount.enable_default_one_time_purchase_label) {
          window.pdpPriceChanged = true
          observer.disconnect();
        break;
        }
        const discountLabel = oneTimeContainer.querySelector('.discount-label')
        discountLabel.innerText = window.autoDiscount.one_time_purchase_label

        window.pdpPriceChanged = true
        observer.disconnect();
        break;
      }
    });

    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function collectionPageChangePrice() {
    if(window?.autoDiscount?.percentValue === 0) {
      return
    }

    const productGrid = document.querySelector(".product-grid")
    if (!productGrid) {
      throw new Error('Product grid not found. [class=".product-grid"]')
    }

    const productList = Array.from(productGrid.querySelectorAll('.grid__item'))

    productList.forEach(productCard => {
      const oldPrice = productCard.querySelector('.custom-compare-at-price').innerText

      const {
        amount: price,
        currency
      } = parseCurrencyAmount(oldPrice)

      const newPrice = subtractPercentage(price, window.autoDiscount.percentValue)
      const newPriceLabel = `${currency}${newPrice}`

      const newPriceElement = productCard.querySelector('.custom-discount-price')
      newPriceElement.innerText = newPriceLabel
    })
  }
})();

function parseCurrencyAmount(str) {
  const currencyMatch = str.match(/[^\d\s.,-]+/);
  const cleanedStr = str.replace(/[^\d.-]/g, '');
  const amount = parseFloat(cleanedStr);

  return {
    amount: isNaN(amount) ? null : amount,
    currency: currencyMatch ? currencyMatch[0] : null
  };
}

function subtractPercentage(amount, percentage) {
  if (typeof amount !== 'number' || typeof percentage !== 'number') {
    throw new Error('Both amount and percentage must be numbers');
  }
  
  const value = amount - (amount * (percentage / 100));
  
  const factor = Math.pow(10, 2);
  const roundedValue = Math.ceil(value * factor) / factor;

  return roundedValue.toFixed(2);
}